/* eslint-disable react/prop-types */
import 'intersection-observer';

import * as React from 'react';
import styled from 'styled-components';
import { withHomePageSection } from 'components/withHomePageSection';
import { ClassScheduleOfLevel } from 'shared/CourseLanding/Detail/ClassScheduleOfLevel';
import { ClassTeacherOfLevel } from 'shared/CourseLanding/Detail/ClassTeacherOfLevel';
import { FAQ } from 'shared/CourseLanding/Detail/CourseFAQ';
import { GGSheetScholarships } from 'shared/CourseLanding/Detail/DetailScholarships';
import { Header as DetailHeader } from './Header';
import { OtherClasses } from 'shared/CourseLanding/Detail/OtherClasses';
import { GCMSRequirements } from 'shared/CourseLanding/Detail/Requirements';
import { SyllabusDetail } from 'shared/CourseLanding/Detail/SyllabusDetail';
import { WhatYouWillGet } from 'shared/CourseLanding/Detail/WhatYouWillGet';
import { useAllTeacherData } from 'shared/DolTeachers/AllDolTeachers';
import StudentReviews from 'shared/StudentCourseLanding/StudentReviews';
import { fromScreen } from 'utils/media-query/responsive.util';
import { colorsV2 } from 'style/colors-v2';
import { useWindowSize } from 'utils/hooks/useWindowSize';
import { StickyCourseHeader } from 'shared/CourseLanding/Detail/StickyCourseHeader';
import { StickyCourseProvider } from 'shared/CourseLanding/Detail/StickyCourseContext';
import { StickyGGSheetScholarships } from 'shared/CourseLanding/Detail/StickyGGSheetScholarships';
import { LevelContext } from 'shared/Marketing/Online/DolRegister/components/withProgramByLevel';
import HallOfFame, { HOFContainer } from 'shared/HallOfFame';
import { getClassGroupName } from 'utils';
import { FAQByClassGroup } from 'shared/CourseLanding/Detail/CourseFAQByClassGroup';

const Wrapper = styled.div`
  .scholarship-desktop-only {
    display: none;
  }
  .section + .section {
    padding-top: 26px;
  }
  section {
    position: relative;
    z-index: 1;
    &:nth-child(n + 3) {
      z-index: 2;
    }
  }
  .breadcrumb {
    a:last-child > p {
      color: ${colorsV2.black80};
    }
  }

  ${HOFContainer} {
    button {
      width: 100%;
    }
  }

  ${fromScreen(776)} {
    .section + .section {
      padding-top: 32px;
    }
  }

  ${fromScreen(1144)} {
    .scholarship-desktop-only {
      display: block;
    }
    section {
      display: block;
      position: relative;
      z-index: 1;
      &:nth-child(n + 3) {
        display: block;
      }
      &:nth-child(n + 3):not(:nth-child(7)):not(:nth-child(8)) {
        z-index: 1;
      }
    }
    section:nth-child(7),
    section:nth-child(8) {
      z-index: 1;
    }
    #what-you-will-get,
    #class-teacher-of-level,
    #faq-section,
    #class-schedule-of-level,
    #other-classes,
    #course-landing-detail-requirements,
    #syllabus-detail,
    ${HOFContainer} {
      max-width: 712px;
    }
    #course-landing-student-reviews {
      width: 712px;
      .card-review {
        min-width: 712px;
        max-width: 712px;
      }
    }
  }
`;

const StudentReviewsWrapper = styled.div`
  .see-more-review {
    button {
      width: 100%;
    }
  }
  .bubble > span {
    font-size: 20px;
    line-height: 28px;

    ${fromScreen(776)} {
      font-size: 24px;
      line-height: 32px;
    }
  }
`;

export const getProgramByClassGroup = ({ classGroup = '' }) => {
  let program = 'IELTS';
  if (classGroup.includes('SAT')) {
    program = 'SAT';
  } else if (classGroup.includes('TOEIC')) {
    program = 'TOEIC';
  } else if (classGroup.includes('GMAT/GRE')) {
    program = 'GMAT/GRE';
  } else if (classGroup.includes('Junior')) {
    program = 'Junior';
  }
  return program;
};

const HallOfFameSection = withHomePageSection(
  ({ classGroup }) => {
    return (
      <HallOfFame
        isDetailCourse
        program={getProgramByClassGroup({ classGroup })}
      />
    );
  },
  {
    style: {
      paddingTop: 32,
      paddingBottom: 32
    },
    selfish: true
  }
);

const DetailTemplate = React.memo(props => {
  const { level, syllabus, otherClasses, rating } = props || {};
  const { getTeacherOfLevel } = useAllTeacherData();

  const teachers = getTeacherOfLevel(level.level);
  const [, updateState] = React.useState();
  const forceUpdate = React.useCallback(() => updateState({}), []);
  useWindowSize(forceUpdate);

  return (
    <LevelContext.Provider value={level.level}>
      <Wrapper>
        {/* <FixedTopBarScholarshipScheduleNOffline /> */}
        {/*<LandingCourseDetailPromotion />*/}
        <StickyCourseProvider>
          <DetailHeader rating={rating} level={level} teachers={teachers} />
          <div className="scholarship-desktop-only">
            <StickyCourseHeader rating={rating} level={level} />
            <StickyGGSheetScholarships
              level={level}
              syllabus={syllabus}
              rating={rating}
            />
          </div>

          <GGSheetScholarships
            showVideo={false}
            level={level}
            syllabus={syllabus}
            rating={rating}
          />
        </StickyCourseProvider>

        <WhatYouWillGet level={level} />
        <SyllabusDetail syllabus={syllabus} level={level} />
        <ClassTeacherOfLevel
          levels={[level.level]}
          levelGroupName={level.levelDisplay}
        />
        {!level.classGroup.includes('GMAT/GRE') && (
          <Reviews classGroup={level.classGroup} />
        )}
        {!level.classGroup.includes('TOEIC') && (
          <HallOfFameSection classGroup={level.classGroup} />
        )}
        {!level.classGroup.includes('GMAT/GRE') && (
          <ClassScheduleOfLevel level={level} />
        )}
        <GCMSRequirements />
        {/*<div id="course-landing-detail-includes-slot" />*/}
        {otherClasses.length > 0 ? (
          <OtherClasses classes={otherClasses} classGroup={level.classGroup} />
        ) : null}
        {level.classGroup.includes('GMAT/GRE') ? (
          <FAQByClassGroup
            classGroup={getProgramByClassGroup({
              classGroup: level.classGroup
            })}
          />
        ) : (
          <FAQ />
        )}
        <div
          id={'course-landing-detail-bottom'}
          style={{
            position: 'absolute',
            bottom: 32,
            left: 0
          }}
        />
      </Wrapper>
      {/* <CallPhoneFab className="mobile-only tablet-only d-flex" /> */}
      {/*<CustomMessengerFab className="mobile-only tablet-only d-flex" />*/}
    </LevelContext.Provider>
  );
});

const Reviews = withHomePageSection(
  ({ classGroup }) => (
    <StudentReviewsWrapper>
      <StudentReviews
        program={getClassGroupName(classGroup)}
        titleDetailCourse={`Review học viên ${classGroup} tại DOL`}
        columns={{ default: 2, 775: 1 }}
      />
    </StudentReviewsWrapper>
  ),
  { selfish: true, style: { backgroundColor: colorsV2.white100 } }
);

DetailTemplate.propTypes = {};

export default DetailTemplate;
